module.exports = __webpack_public_path__ + "img/button_01pc.c65ae387.webp";